import { Stack } from '@mui/material';
import SettingCard from '@/components/SettingCard';
import DimentionSettings from '../DimentionSettings/DimentionSettings';
import MapSettings from './MapSettings';

const MapBlockSettings = () => {
  return (
    <Stack spacing={2}>
      <SettingCard title="Tamaño">
        <DimentionSettings />
      </SettingCard>
      <SettingCard title="Coordenadas">
        <MapSettings />
      </SettingCard>
    </Stack>
  );
};

export default MapBlockSettings;
